'use client';

import {
  Control,
  UseFormRegister,
  UseFormSetValue,
  UseFormTrigger,
} from 'react-hook-form';
import { FormData } from '@/types/form';
import AddressFormModal from './AddressFormModal';
import AddressFormModalManual from './AddressFormModalManual';
import useModal from '@/hooks/useModal';

interface Props {
  register?: UseFormRegister<FormData>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control?: Control<FormData, any, FormData>;
  setValue?: UseFormSetValue<FormData>;
  trigger?: UseFormTrigger<FormData>;
  handleSubmit?: (e?: React.BaseSyntheticEvent) => Promise<void>;
  formData?: FormData;
}

const ModalForm = ({
  register,
  control,
  setValue,
  trigger,
  handleSubmit,
  formData,
}: Props) => {
  const { closeModal } = useModal();
  if (formData?.address_variant === 'google') {
    return (
      <AddressFormModal
        formData={formData}
        register={register}
        control={control}
        setValue={setValue}
        trigger={trigger}
        handleSubmit={handleSubmit}
        closeModal={closeModal}
      />
    );
  }
  return (
    <AddressFormModalManual
      formData={formData}
      register={register}
      control={control}
      setValue={setValue}
      trigger={trigger}
      handleSubmit={handleSubmit}
      closeModal={closeModal}
    />
  );
};

export default ModalForm;
